// NOTE: NSAI-7350 — the members panel is drawn like every other menu surface in
// the app (DropdownMenuContent / PopoverContent): a 4px gap below its trigger,
// `rounded-md`, a border, `shadow-md`, and rows inset by `p-1`.
export const SUGGESTIONS_PANEL_CLASS_NAME =
  "absolute end-0 start-0 top-full z-50 mt-1 overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md";

// NOTE: The panel already insets its rows, so the groups drop cmdk's own `p-1`
// rather than doubling it, and `overflow-visible` undoes the primitive's
// `overflow-hidden`, which would otherwise trap the sticky heading inside its
// own group box. The group heading sticks to the top of the scrolled
// list on the panel's own surface, so a long list never shows a heading sliced
// in half above the first visible row.
export const SUGGESTIONS_GROUP_CLASS_NAME =
  "overflow-visible p-0 [&_[cmdk-group-heading]]:sticky [&_[cmdk-group-heading]]:-top-1 [&_[cmdk-group-heading]]:z-10 [&_[cmdk-group-heading]]:bg-popover";
